module.exports = __webpack_public_path__ + "static/img/check-icon.e97497b2.png";